import React, { useState, useEffect } from 'react';
import ReactEcharts from 'echarts-for-react';
import { Card, Elevation } from '@blueprintjs/core';
import apiBacen from '../../../Services/apiBacen';
import echarts from 'echarts';

interface ApiSelic {
    data: string;
    valor: number;
}

const LinePercent: React.FC = (params) => {

    const [selic, setSelic] = useState<ApiSelic[]>([]);

    useEffect(() => {
        apiBacen.get('bcdata.sgs.4189/dados?formato=json')
            .then(response => {
                setSelic(response.data)
            })
    }, [])

    const DataIni = Date.parse("01/01/2000");

    //const colors = ['#5793f3', '#d14a61', '#675bba'];


    return (
        <Card style={{ width: "1500px", background: "transparent", boxShadow: "none", margin: "200px 0 0 200px" }} elevation={Elevation.TWO} interactive={true}>
            <ReactEcharts

                option={{

                    tooltip: {
                        trigger: 'axis',
                        position: function (pt: any) {
                            return [pt[0], '10%'];
                        }
                    },
                    title: {
                        text: 'Variação  Taxa Selic (%)',
                        textStyle: {
                            color: "#ffffff"
                        }
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        axisLabel: {
                            textStyle: {
                                color: '#ffffff'
                            }
                        },
                        data: selic.filter(seli => Date.parse(seli.data) > DataIni)
                            .map(seli => seli.data)
                    },
                    yAxis: {
                        type: 'value',
                        boundaryGap: [0, '100%'],
                        axisLabel: {
                            textStyle: {
                                color: '#ffffff'
                            }
                        }
                    },
                    dataZoom: [{
                        type: 'inside',
                        start: 0,
                        end: 10
                    }, {
                        start: 0,
                        end: 10,
                        handleIcon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
                        handleSize: '80%',
                        handleStyle: {
                            color: '#fff',
                            shadowBlur: 3,
                            shadowColor: 'rgba(0, 0, 0, 0.6)',
                            shadowOffsetX: 2,
                            shadowOffsetY: 2
                        }
                    }],
                    series: [
                        {
                            name: 'Valor',
                            type: 'line',
                            smooth: true,
                            symbol: 'none',
                            sampling: 'average',
                            itemStyle: {
                                color: 'rgb(255, 70, 131)'
                            },
                            areaStyle: {
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: '#675bba'
                                }, {
                                    offset: 1,
                                    color: '#5793f3'
                                }])
                            },
                            data:
                                selic
                                    .filter(seli => Date.parse(seli.data) > DataIni)
                                    .map(seli => seli.valor),
                            label: {
                                normal: {
                                    show: true,
                                    position: 'top'
                                }
                            },
                        }
                    ]
                }}
            />
        </Card>
    )
}



export default LinePercent;